import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LogIn } from "lucide-react";
import { motion } from "framer-motion";

const LoginButton = ({ className = "", rounded = "rounded-xl" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = location.pathname === "/login";

  return (
    <div className="relative h-20 flex items-center justify-center">
      <button
        onClick={() => navigate("/login")}
        className={`
          group relative flex items-center justify-center 
          min-w-[140px] px-12 py-3 
          bg-[#004A8D] hover:bg-[#003566] 
          text-white font-black text-[13px] uppercase tracking-[0.15em] 
          transition-all duration-300 shadow-md hover:shadow-lg active:scale-95 
          ${rounded} ${className}
        `}
      >
        <LogIn size={18} className="hidden xl:block mr-2 transition-transform group-hover:translate-x-1" />
        <span className="whitespace-nowrap">LOGIN</span>
      </button>
      {isActive && (
        <motion.div 
          layoutId="navbar-underline" 
          className="absolute bottom-[-4px] left-4 right-4 h-[3px] bg-[#044A8C] z-[60]" 
          transition={{ type: "spring", stiffness: 380, damping: 30 }} 
        />
      )}
    </div>
  );
};

export default LoginButton;